export default {

  mounted(){
        window.onscroll = function () {
          myFunction()
        };
        var header = document.getElementById("header");
        var sticky = header.offsetTop;

        function myFunction() {
          if (window.pageYOffset > sticky) {
            header.classList.add("show-menu");
          } else {
            header.classList.remove("show-menu");
          }
        }

        window.addEventListener('scroll', handleScroll);

        function handleScroll() {
          var totalItems = $("[data-scroll-section]").length;
          $("[data-scroll-section]").each(function (index) {
            var item = $(this)[0];
            var offset = -150;
            var className = $(this).attr("data-scroll-section");
            const elTop = item.getBoundingClientRect().top + offset;
            const elBottom = item.getBoundingClientRect().bottom + offset;
            const elheight = item.getBoundingClientRect().height;
            var navElem = $(".c-eric-progress-el").find('#' + className);
            var progress = navElem.find(".c-eric-progress__progress");
            var numItems = $(".c-eric-progress__counter-item");
            var percNumb = (100 / totalItems) * (index);
            if (elTop > 0) {
              navElem.addClass("c-eric-progress__next");
              navElem.removeClass("c-eric-progress__prev");
            }
            if (elBottom < 0) {
              navElem.addClass("c-eric-progress__prev");
              navElem.removeClass("c-eric-progress__next");
            }
            if (elTop <= 0 && elBottom >= 0) {
              var percentage = (Math.abs(elTop) * 100) / elheight;
              navElem.removeClass("c-eric-progress__prev");
              navElem.removeClass("c-eric-progress__next");
              progress.css("height", percentage + "%");
              numItems.css("transform", "translateY(-" + percNumb + "%)")
            }
          })
        }
        $("[data-scroll-section]").each(function (index) {
          var section = $(this).attr("data-scroll-section");
          $(".c-eric-progress-el").append(`
                        <div id="${section}" class="c-eric-progress__background c-eric-progress__next">
                            <div class="c-eric-progress__progress" >
                            </div>
                        </div>
                      `);
          $(".c-eric-progress__counter-item").append("<div>" + (index + 1) + "</div>")
        });
        $(document).on("click", ".c-eric-progress__background", function () {
          var id = $(this).attr("id");
  
          var val = $("[data-scroll-section=\"" + id + "\"]").offset().top - 100;
          window.scrollTo({
            top: val,
            behavior: 'smooth'
          });
        });
}
};



// WEBPACK FOOTER //
// ./src/mixins/global.js